const _ = require('lodash');

class CorporateHeaderController {
    constructor($state) {
        this.$state = $state;
    }

    /**
     * The shopping link is active at all times EXCEPT for when we
     * are on store locator OR the rewards page in Discover.
     *
     * @returns {boolean}
     *
     * @memberOf CorporateHeaderController
     */
    isShoppingActive() {
        const exceptStates = [
            { state: 'shop.locator' },
            { state: 'shop.inspiration.parent', params: { parent: 'woolworths-rewards' } },
        ];

        return !(_.some(exceptStates, s => this.$state.is(s.state, s.params)));
    }
}

const corporateHeaderComponentDefinition = {
    bindings: {
        classModifier: '@?',
    },
    controller: ['$state', CorporateHeaderController],
    template: require('./corporate-header.component.html').trim(),
};

module.exports = {
    corporateHeaderComponentDefinition,
    CorporateHeaderController,
};



// WEBPACK FOOTER //
// ./src/shop/header/corporate-header.component.js